export var Paths;

(function (Paths) {
  Paths["Show"] = "/videos/:videoId";
  Paths["ListRecommended"] = "/videos/:videoId/recommended";
  Paths["ListRelatedEndpoints"] = "/videos/:videoId/related_endpoints";
  Paths["ListRelated"] = "/videos/:videoId/related";
  Paths["GetToken"] = "/videos/:videoId/token";
  Paths["GetSources"] = "/videos/:videoId/sources";
  Paths["GetCanWatch"] = "/videos/:videoId/can_watch";
  Paths["GetCanWatchWithPin"] = "/videos/:videoId/can_watch_with_pin";
  Paths["GetInteractions"] = "/videos/:videoId/has_interacted";
  Paths["Like"] = "/videos/:videoId/like";
  Paths["Unlike"] = "/videos/:videoId/like";
  Paths["Review"] = "/videos/:videoId/review";
})(Paths || (Paths = {}));